<template>
    <template v-if="items.length > 0">
        <v-row>
            <v-col no-gutters cols="12" md="6" v-for="item in items" :key="item.assignedTaskId">
                <task-content-card :item="item" @update-task-status="updateTaskStatus"></task-content-card>
            </v-col>
        </v-row>
    </template>
    <template v-else>
        <v-sheet class="pa-4" height="100%">
            <v-card outlined>
                <v-card-title class="mont-font mont-bold text-center">
                    No content available
                </v-card-title>
            </v-card>
        </v-sheet>
    </template>
</template>

<script>
import TaskContentCard from './TaskContentCard.vue';
export default {
    name: "TaskContentList",
    components: {
        TaskContentCard
    },
    data() {
        return {
            currentSlide: 0, // Track the current slide
            videoWidth: 'auto',  // Dynamically adjust video width
        };
    },
    props: {
        items: {
            type: Array,
            required: true,
        },
    },
    emits: ['updateTaskStatus'],
    methods: {
        isYouTubeLink(url) {
            const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)(\/.*)?$/;
            return youtubeRegex.test(url);
        },
        convertToEmbedLink(watchLink) {
            if (watchLink.includes('youtube.com/watch?v=')) {
                return watchLink.replace('watch?v=', 'embed/');
            }
            console.error('Invalid YouTube watch link');
            return null;
        },
        updateTaskStatus(task){
            console.log(`List status update method: ${task.item}`);
            this.$emit("updateTaskStatus", task);
        },
        updateVideoWidth() {
            this.videoWidth = `${window.innerWidth / 1.3}px`;
        },
    },
    watch: {

    },
    mounted() {
        this.updateVideoWidth();
        window.addEventListener('resize', this.updateVideoWidth);
    },
};
</script>

<style scoped>
.no-decoration {
    text-decoration: none;
    color: #000000de
}
</style>